import type { ThemeAITheme } from '../types/gotypes'

// Each theme gets its own colour, so choosing "Gift shop" shows its bar, and
// the words it matched in each response, in that theme's colour (Matt, 24 Sep,
// #1523 item 6). Colours follow the frame's order, so a theme keeps its colour
// across runs and between the chart and the responses. Mid-tone hues that
// read on both the light and dark themes; a frame longer than the palette
// reuses it.
export const THEME_PALETTE = [
  '#4E79C7', // blue
  '#8E6BC4', // purple
  '#E48A3C', // orange
  '#3FA37A', // green
  '#D65A5A', // red
  '#2C9A9A', // teal
  '#C9699C', // pink
  '#B89A2E', // ochre
  '#6F7FD6', // periwinkle
  '#7F9A3E', // olive
  '#B5714E', // clay
  '#5C8FA8', // steel
]

// themeColourFor returns a lookup from a theme code to its colour. Codes are
// the strings the results carry ("1", "2"); a code the frame no longer has
// (an old run) gets a colour from its position after the frame's own.
export const themeColourFor = (themes: ThemeAITheme[]) => {
  const ordered = [...themes].sort((a, b) => a.order - b.order || a.code - b.code)
  const index = new Map(ordered.map((theme, i) => [String(theme.code), i]))
  return (code: string | undefined): string | undefined => {
    if (code === undefined) return undefined
    const i = index.get(code) ?? (index.size + (Number.parseInt(code, 10) || 0))
    return THEME_PALETTE[i % THEME_PALETTE.length]
  }
}
